import { configureStore } from "@reduxjs/toolkit";
import { adminReducer } from "../slices/index.js";
import storeReducer, { resetStore } from "../slices/store.js";
import { logoutUser } from "../slices/user.js";

type RootReducer = typeof adminReducer;
export type StoreState = ReturnType<RootReducer>;

const createRootReducer: (initialState: StoreState) => RootReducer =
  (initialState) => (state, action) => {
    if (logoutUser.match(action) || resetStore.match(action)) {
      state = initialState;
    }
    const adminReducerState = adminReducer(state, action);
    const storeReducerState = storeReducer(adminReducerState, action);

    return storeReducerState;
  };

const configStore = (initialState: StoreState) =>
  configureStore({
    reducer: createRootReducer(initialState),
    preloadedState: initialState,
  });

export default configStore;
